"use client";

import { c as _c } from "react/compiler-runtime";
import { RiAddLine } from "react-icons/ri";
import { Button } from "@/components/ui";
import { useSequences } from "./context";
interface AddButtonProps {
  /**
   * Parent-owned create handler. Typically calls `add()` + `setEditingKey()`
   * and pushes a history entry; this component only renders the button.
   */
  onCreate: () => void;
}
export function AddButton(t0) {
  const $ = _c(3);
  const {
    onCreate
  } = t0;
  const {
    meta: t1
  } = useSequences();
  const {
    readOnly
  } = t1;
  if (readOnly) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <RiAddLine />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onCreate) {
    t3 = <Button variant="secondary" type="button" onClick={onCreate} icon={t2} size="sm" className="w-full">Add Message</Button>;
    $[1] = onCreate;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}